import { Component, inject, Input, OnInit } from '@angular/core';
import { Transporter } from '../../../../../models/transporter.model';
import { ITransportConfiguration } from '../../../../../models/transport-configuration.model';
import { OfferService } from '../../../../../services/offer.service';
import { Offer } from '../../../../../models/offer.model';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { DateUtil } from '../../../util/date-util';
import { TransportFormGroup } from '../../../../../models/forms/TransportFormGroup';

@Component({
  selector: 'jhi-transport-parameters-card[transportForm]',
  templateUrl: './transport-parameters-card.component.html',
  styleUrls: ['./transport-parameters-card.component.scss'],
})
export class TransportParametersCardComponent implements OnInit {
  readonly #offerService = inject(OfferService);
  readonly #translateService = inject(TranslateService);
  readonly #datePipe = inject(DatePipe);

  @Input() transportConfiguration!: ITransportConfiguration;
  @Input() transporter!: Transporter;
  @Input() transportForm!: TransportFormGroup;
  @Input() options!: { isPickup: boolean };
  @Input() isUpdate?: boolean;

  public offerSelected!: Offer;
  public labelFlexibilityDeliveryDate: string = ``;

  private DEFAULT_OPTIONS = {
    isPickup: true,
  };

  get title(): string {
    if (this.isUpdate) {
      return '';
    } else {
      if (this.options.isPickup) {
        return 'TITLE.PICKUP';
      } else {
        return 'TITLE.DELIVERY';
      }
    }
  }

  switchCase<T>(pickupVal: T, deliveryVal: T): T {
    return this.options.isPickup ? pickupVal : deliveryVal;
  }

  ngOnInit(): void {
    this.options = { ...this.DEFAULT_OPTIONS, ...this.options };
    if (this.options.isPickup) {
      this.transportForm.controls.pickupComments.valueChanges.subscribe(change =>
        this.transportForm.controls.pickupComments.setValue(change?.replace(/\r\n|\n|\r/gm, ' '), { emitEvent: false })
      );
    } else {
      this.transportForm.controls.deliveryComments.valueChanges.subscribe(change =>
        this.transportForm.controls.deliveryComments.setValue(change?.replace(/\r\n|\n|\r/gm, ' '), { emitEvent: false })
      );

      if (this.transportForm.controls.offerId?.value) {
        this.#offerService.getTransportOffer(this.transportForm.controls.offerId.value).subscribe({
          next: offer => {
            this.offerSelected = offer;
            if (this.offerSelected?.flexibilityDeadline) {
              this.refreshLabelMaxDate(this.transportForm.controls.deliveryDate.value);
              this.transportForm.controls.deliveryDate.valueChanges.subscribe(val => this.refreshLabelMaxDate(val));
            }
          },
        });
      }
    }
  }

  private refreshLabelMaxDate(deliveryDate: any): void {
    const maxDeliveryDate = DateUtil.addBusinessDays(deliveryDate, Number(this.offerSelected.flexibilityDeadline));
    this.labelFlexibilityDeliveryDate = this.#translateService.instant('baryApp.offer.info-charger-flexibility-offer', {
      date1: this.#datePipe.transform(deliveryDate.toDate(), 'dd/MM/yyyy'),
      date2: this.#datePipe.transform(maxDeliveryDate, 'dd/MM/yyyy'),
    }) as string;
  }
}
